import { createSelector } from 'reselect'
import { parseURLParams, removeTrailingSlash } from '@offerzen/pinata-shame'

export const getLocation = state => state.router.location

export const urlPath = createSelector([getLocation], location => removeTrailingSlash(location.pathname))
export const urlSearch = createSelector([getLocation], location => location.search)
export const urlParams = createSelector([getLocation], location => parseURLParams(location.search))
export const urlHash = createSelector([getLocation], location => location.hash.replace('#', ''))
export const previousUrl = createSelector([getLocation], location => location.state?.url)
